import React from 'react'
import { MerchantContext, SetupMerchant } from './index'
import { MessageStoreContext, SetupMessageStore } from './useMessageStore'
import { IntegrationContext, SetupIntegration } from './useIntegration'
import { ModifierGroupsContext, SetupModifierGroups } from './useModifierGroups'
import {
  StoreOrderTypeCapacityContext,
  SetupStoreOrderTypeCapacity
} from './useStoreOrderTypeCapacity'

export const GlobalContext = ({ children }: { children?: React.ReactNode }) => {
  return (
    <MerchantContext.Provider value={SetupMerchant()}>
      <MessageStoreContext.Provider value={SetupMessageStore()}>
        <IntegrationContext.Provider value={SetupIntegration()}>
          <ModifierGroupsContext.Provider value={SetupModifierGroups()}>
            <StoreOrderTypeCapacityContext.Provider
              value={SetupStoreOrderTypeCapacity()}
            >
              {children}
            </StoreOrderTypeCapacityContext.Provider>
          </ModifierGroupsContext.Provider>
        </IntegrationContext.Provider>
      </MessageStoreContext.Provider>
    </MerchantContext.Provider>
  )
}

export default GlobalContext
